module.exports = "/_next/static/media/309947d8c6d22a3bc2404644ad8f237b.png";